<template>
    <div class="form_group form_group_address" :class="'form_group_'+address_name">
        <display-message :option="message_option"></display-message>
        <p>* Must be Australian address.</p>
        <p style="font-size: 0.8em;padding:1em 0;margin:0;font-style: italic;">Search for an address below. If your address does not appear, you can enter it manually below</p>
        <div class="form_row">
            <label :for="address_name+ '_formatted_address'">Find an address</label>
            <div class="address_autocomplete_container">
                <input type="text" :id="address_name+ '_formatted_address'" autocomplete="google_autocomplete" @focus="init_autocomplete" v-model="google_autocomplete_input">
            </div>
        </div>
        <p style="font-size: 0.8em;padding:1em 0;margin:0;font-style: italic;">Enter address manually</p>
        <div class="form_row">
            <label :for="address_name+ '_street_line1'" v-html="cache_data_label.street_line1" v-show="cache_data.street_line1"></label>
            <input type="text" :id="address_name+ '_street_line1'" :placeholder="cache_data_label.street_line1" v-model="cache_data.street_line1" autocomplete="off">
        </div>
        <div class="form_row">
            <label :for="address_name+ '_street_line2'" v-html="cache_data_label.street_line2" v-show="cache_data.street_line2"></label>
            <input type="text" :id="address_name+ '_street_line2'" :placeholder="cache_data_label.street_line2" v-model="cache_data.street_line2" autocomplete="off">
        </div>
        <div class="form_row">
            <label :for="address_name+ '_care_of'" v-html="cache_data_label.care_of" v-show="cache_data.care_of"></label>
            <input type="text" :id="address_name+ '_care_of'" :placeholder="cache_data_label.care_of" v-model="cache_data.care_of">
        </div>
        <div class="form_row">
            <label :for="address_name+ '_suburb'" v-html="cache_data_label.suburb" v-show="cache_data.suburb"></label>
            <input type="text" :id="address_name+ '_suburb'" :placeholder="cache_data_label.suburb" v-model="cache_data.suburb">
        </div>
        <div class="form_row">
            <label :for="address_name+ '_state'" v-html="cache_data_label.state" v-show="cache_data.state"></label>
            <div class="select_container">
                <select :id="address_name+ '_state'" :placeholder="cache_data_label.state" v-model="cache_data.state">
                    <option value="" disabled>-- {{ cache_data_label.state }} --</option>
                    <option value="NSW">NSW</option>
                    <option value="VIC">VIC</option>
                    <option value="QLD">QLD</option>
                    <option value="SA">SA</option>
                    <option value="WA">WA</option>
                    <option value="TAS">TAS</option>
                    <option value="NT">NT</option>
                    <option value="ACT">ACT</option>
                </select>
            </div>
        </div>
        <div class="form_row">
            <label :for="address_name+ '_postcode'" v-html="cache_data_label.postcode" v-show="cache_data.postcode"></label>
            <input type="text" :id="address_name+ '_postcode'" :placeholder="cache_data_label.postcode" v-model="cache_data.postcode">
        </div>
        <div class="form_row form_row_controller_container">
            <input type="button" class="btn btn-primary" value="Save" @click="save(address_name)">
            <input type="button" class="btn btn-secondary-inverse" value="Cancel" @click="cancel()">
        </div>
    </div>    
</template>

<script>
    export default {
        name: "AddNewAddress",
        props: ['option'],
        data() {
            let data_set = {
                google_autocomplete_input:'',
                autocomplete: null,
                cache_data_label: {
                    street_line1: 'Street Address',
                    street_line2: 'Street Address Line 2',
                    care_of: 'Care Of',
                    suburb: 'Suburb',
                    state: 'State',
                    postcode: 'Postcode'
                },
                cache_data: {
                    place_id: '',
                    care_of: '',
                    street_line1: '',
                    street_line2: '',
                    suburb: '',
                    state: '',
                    postcode: '',
                    country: 'Australia',
                    formatted_address: '',
                    id: ''
                },
                message_option: {
                    message: '',
                    message_type: ''
                },
            };
            let current_object = this;
            Object.keys(current_object.option).forEach(function (option_key) {
                data_set[option_key] = current_object.option[option_key];
            });
            return data_set;
        },
        mounted() {

        },
        methods: {
            init_autocomplete: function ($event) {
                let current_object = this;

                if (!current_object.autocomplete) {
                    current_object.autocomplete = new google.maps.places.Autocomplete($event.target, {
                        componentRestrictions: { country: ['au'] },
                        fields: ['place_id', 'address_components', 'formatted_address'],
                        types: ['address'],
                    });

                    current_object.autocomplete.addListener('place_changed', this.fill_google_address);
                }
            },
            fill_google_address: function () {
                let current_object = this;

                if (!current_object.autocomplete) {
                    current_object.message_option.message_type = 'warning';
                    current_object.message_option.message = 'Failed to load '+current_object.address_name+' autocomplete';
                } else {
                    let place = current_object.autocomplete.getPlace();

                    current_object.cache_data.street_line1 = '';
                    current_object.cache_data.street_line2 = '';
                    current_object.cache_data.care_of = '';
                    current_object.cache_data.postcode = '';
                    current_object.cache_data.suburb = '';
                    current_object.cache_data.state = '';
                    current_object.cache_data.country = '';
                    current_object.google_autocomplete_input = '';

                    for (const component of place.address_components) {
                        // @ts-ignore remove once typings fixed
                        const componentType = component.types[0];
// console.log(component,componentType);

                        switch (componentType) {
                            case 'street_number': {
                                current_object.cache_data.street_line1 = `${component.long_name} ${current_object.cache_data.street_line1}`;
                                break;
                            }

                            case 'route': {
                                current_object.cache_data.street_line1 += component.long_name;
                                break;
                            }

                            case 'subpremise':
                                current_object.cache_data.street_line2 = component.long_name;
                                break;

                            case 'point_of_interest':
                                current_object.cache_data.care_of = component.long_name;
                                break;

                            case 'postal_code': {
                                current_object.cache_data.postcode = component.long_name;
                                break;
                            }
                            case 'locality':
                                current_object.cache_data.suburb = component.long_name;
                                break;
                            case 'administrative_area_level_1': {
                                current_object.cache_data.state = component.short_name;
                                break;
                            }
                            case 'country':
                                current_object.cache_data.country = component.long_name;
                                break;
                        }
                    }
                    current_object.cache_data.place_id = place.place_id;
                    current_object.cache_data.formatted_address = place.formatted_address;
                }
            },
            reset_cache_data: function () {
                this.cache_data = {
                    care_of: '',
                    street_line1: '',
                    street_line2: '',
                    suburb: '',
                    state: '',
                    postcode: '',
                    country: 'Australia',
                    formatted_address: '',
                    id: ''
                };
            },
            save: function () {
                let current_object = this;

                let warning_message = [];

                // General Validation, e.g. mandatory field empty, number format wrong...
                Object.keys(current_object.cache_data).forEach(function (field_name) {
                    switch (field_name) {
                        case 'street_line1':
                        case 'suburb':
                        case 'state':
                        case 'postcode':
                            if (current_object.cache_data[field_name] === '') {
                                warning_message.push('Field "'+current_object.cache_data_label[field_name]+'" is required.');
                            }
                            break;
                    }
                });

                if (warning_message.length > 0) {
                    // current_object.display_message(warning_message,{message_type:'error'});
                    current_object.message_option.message_type = 'error';
                    current_object.message_option.message = warning_message;
                    return false;
                } else {
                    // current_object.display_message('');
                    current_object.message_option.message_type = 'success';
                    current_object.message_option.message = '';
                }

                current_object.cache_data.formatted_address = '';
                let formatted_address_stack = [];
                Object.keys(current_object.cache_data).forEach(function (key) {
                    switch (key) {
                        case 'country':
                        case 'formatted_address':
                        case 'place_id':
                        case 'id':
                            break;
                        default:
                            if (current_object.cache_data[key]) {
                                formatted_address_stack.push(current_object.cache_data[key]);
                            }
                    }
                });
                current_object.cache_data.formatted_address = formatted_address_stack.join(', ');
                let index_counter = 1;
                while (current_object.item_map.addresses['new_'+index_counter]) {
                    index_counter++;
                }
                current_object.cache_data.id = 'new_'+index_counter;
                current_object.item_map.addresses['new_'+index_counter] = Object.assign({},current_object.cache_data);
                current_object.item_list.addresses.push(current_object.item_map.addresses['new_'+index_counter]);

//
//                 let i = 1;
//                 let j = 0;
//                 let duplicate_flag = true;
//                 while (duplicate_flag) {
//                     duplicate_flag = false;
//                     for (j=0;j<current_object.item_list.addresses.length;j++) {
//                         if (current_object.item_list.addresses[j]['id'] == 'new_'+i) {
//                             i++;
//                             duplicate_flag = true;
//                             break;
//                         }
//                     }
//                 }
//                 current_object.cache_data.id = 'new_'+i;
// console.log('apply new address',current_object.item_list.addresses,current_object.cache_data);
//                 current_object.item_list.addresses.push(current_object.cache_data);

                // $('html, body').stop().animate({
                //     scrollTop:$(current_object.$el).offset().top - 200
                // }, 550, 'swing', function () {
                //     // When message box display for the first time, container does not exist and scroll to position would be the bottom of container instead of top
                //     // (calculated top position number is correct, it is kind of browser render problem)
                //     // Do scrollTop again after 0.5s (vue fade-in animate time by css) would fix the problem
                //     // scrollTop:$(current_object.$el).offset().top - 200;
                // });
                $('html, body').scrollTop($(current_object.$el).offset().top - 200);
                current_object.$emit('update:new_address',this.cache_data.id);
                current_object.reset_cache_data();
            },
            cancel: function () {
                let current_object = this;
                // $('html, body').stop().animate({
                //     scrollTop:$(current_object.$el).offset().top - 200
                // }, 550, 'swing', function () {
                //     // When message box display for the first time, container does not exist and scroll to position would be the bottom of container instead of top
                //     // (calculated top position number is correct, it is kind of browser render problem)
                //     // Do scrollTop again after 0.5s (vue fade-in animate time by css) would fix the problem
                //     // scrollTop:$(current_object.$el).offset().top - 200;
                // });
                $('html, body').scrollTop($(current_object.$el).offset().top - 200);
                current_object.$emit('update:new_address','');
                current_object.reset_cache_data();
            }
        }
    }
</script>